import { Spinner, VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type LoadingProps = {
  text?: string;
};

export const Loading: React.FC<PropsWithChildren<LoadingProps>> = ({ text }) => {
  return (
    <VStack height="100%" justifyContent={'center'} backgroundColor="transparent">
      {text && <TextBlock padding="40px">{text}</TextBlock>}
      <Spinner />
    </VStack>
  );
};
